import { faTrash, faUserXmark } from "@fortawesome/pro-solid-svg-icons";
import { clsx } from "clsx";
import { type PropsWithChildren } from "react";

import { Button } from "~/components";
import { CollectLeaveGuard } from "~/components/pos/collect/collect-leave-guard";
import { SplitPaymentGuard } from "~/components/pos/payment/split-payment-guard";
import { basketActions } from "~/providers/store/basket";
import { collectActions } from "~/providers/store/collect/actions";
import { employeeActions } from "~/providers/store/employee";

export type BasketHeaderWrapperProps = {
  isEmpty: boolean;
  isAuthenticated: boolean;
};

export const BasketHeaderWrapper = ({
  children,
  isEmpty,
  isAuthenticated
}: PropsWithChildren<BasketHeaderWrapperProps>) => {
  return (
    <div className="flex justify-between gap-2 border-b border-divider-main p-3">
      {children}

      <div className="flex items-start gap-3">
        {isAuthenticated ? (
          <CollectLeaveGuard variant="cancel-basket">
            <Button
              icon={faUserXmark}
              onClick={() => {
                basketActions.reset();
                basketActions.resetDiningOption();
                basketActions.removeRedeemed();
                employeeActions.reset();
                collectActions.reset();
              }}
              variant="danger-light"
            />
          </CollectLeaveGuard>
        ) : null}

        <SplitPaymentGuard>
          <Button
            onClick={() => {
              basketActions.reset();
            }}
            className={clsx("border border-divider-main", {
              invisible: isEmpty && !isAuthenticated
            })}
            icon={faTrash}
            variant="light"
            disabled={isEmpty}
          />
        </SplitPaymentGuard>
      </div>
    </div>
  );
};
